import { spaceClient } from './client';

export const submitApproval = (payload) =>
  spaceClient.post('/approvals', payload).then((r) => r.data);

export const withdrawApproval = (approvalId) =>
  spaceClient.patch(`/approvals/${approvalId}/withdraw`, {}).then((r) => r.data);

export const approveApproval = (approvalId) =>
  spaceClient.patch(`/approvals/${approvalId}/approve`, {}).then((r) => r.data);

export const rejectApproval = (approvalId, reason) =>
  spaceClient.patch(`/approvals/${approvalId}/reject`, { reason }).then((r) => r.data);

export const getInbox = () =>
  spaceClient.get('/approvals/inbox', { _silent: true }).then((r) => r.data);

export const getMySubmissions = () =>
  spaceClient.get('/approvals/my-submissions').then((r) => r.data);

export const getApprovalById = (approvalId) =>
  spaceClient.get(`/approvals/${approvalId}`).then((r) => r.data);
